"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
/**
 * Adding sticky contact buttons.
 *
 * @author Kevin Buchholz <kevin.buchholz@wendweb.de>
 */
var ContactButtons = /** @class */ (function () {
    function ContactButtons(selector) {
        var _this = this;
        this.contactButtons = document.querySelector(selector);
        if (this.contactButtons) {
            this.contactButtonWrapper = this.contactButtons.querySelector("[".concat(constants_1.DATA_CONTACT_BUTTONS_WRAPPER, "]"));
            this.contactButtonActions = this.contactButtons.querySelector("[".concat(constants_1.DATA_CONTACT_BUTTONS_ACTIONS, "]"));
            window.addEventListener('scroll', function () {
                // Let div appear from bottom on page load
                if (!_this.isFirstLoad) {
                    _this.contactButtons.classList.remove(constants_1.CLASS_STICKY_HIDDEN);
                    _this.isFirstLoad = true;
                }
                _this.checkScrollPosition();
            });
            // window.addEventListener('resize', () => {
            //   this.updateWidth();
            // });
        }
    }
    /**
     * Check if contact-buttons element should be sticky
     */
    ContactButtons.prototype.checkScrollPosition = function () {
        // Element has not reached bottom (add sticky)
        if (window.innerHeight - this.contactButtons.getBoundingClientRect().bottom < 0) {
            this.contactButtons.classList.add(constants_1.CLASS_STICKY);
            if (!this.isWidthCalculated) {
                // this.setWidth();
                this.isWidthCalculated = true;
            }
        }
        // Element is beyond anchor position (Remove sticky)
        else {
            this.contactButtons.classList.remove(constants_1.CLASS_STICKY);
            this.contactButtonWrapper.style.removeProperty('width');
            this.isWidthCalculated = false;
        }
    };
    /**
     * Calculate and set width for sticky view
     */
    ContactButtons.prototype.setWidth = function () {
        var currentWidth = this.contactButtonActions.offsetWidth;
        var styleWrapper = window.getComputedStyle(this.contactButtonWrapper);
        var padding = parseFloat(styleWrapper.paddingLeft) +
            parseFloat(styleWrapper.paddingRight);
        var resultWidth = currentWidth + padding;
        this.contactButtonWrapper.style.width = "".concat(resultWidth, "px");
    };
    /**
     * Update width on viewport change if sticky
     */
    ContactButtons.prototype.updateWidth = function () {
        if (this.contactButtons.classList.contains(constants_1.CLASS_STICKY)) {
            this.setWidth();
        }
    };
    return ContactButtons;
}());
exports.default = ContactButtons;
